import { Link } from 'react-router-dom';
import { CategoryData } from '../data';

import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

interface Props {
    data: CategoryData;
}

export const CategoryCard = ({ data }: Props) => {
    return (
        <Card
            sx={{
                height: '100%',
            }}
        >
            <CardActionArea
                component={Link}
                to={`/categories/${data.categoryId}`}
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <CardMedia
                    component="img"
                    alt={data.name}
                    src={`/static/categories/${data.icon}`}
                    sx={{
                        width: 60,
                        height: 60,
                        margin: '0 auto',
                        pt: 1.5,
                    }}
                />
                <CardContent sx={{ flex: 1 }}>
                    <Typography gutterBottom variant="h5" component="h2" align="center">
                        {data.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p" align="center">
                        {data.description}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};
